import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Mail, Lock, AlertCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { useAuth } from '../utils/auth';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const success = await login(email, password);
      if (success) {
        navigate('/');
      } else {
        setError('Email ou mot de passe incorrect');
      }
    } catch (err) {
      setError('Une erreur est survenue');
    } finally {
      setIsLoading(false);
    }
  };
  const quickLogin = (role: 'admin' | 'bureau' | 'chef_equipe' | 'technicien') => {
    const emails: Record<string, string> = {
      admin: 'naoufel@francedecoration.fr',
      bureau: 'randa@francedecoration.fr',
      chef_equipe: 'mohamad@francedecoration.fr',
      technicien: 'karim@francedecoration.fr'
    };
    setEmail(emails[role]);
    setPassword('demo123');
  };
  return <div className="min-h-screen gradient-fd flex items-center justify-center p-4" data-id="element-645">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="w-full max-w-md" data-id="element-646">
        {/* Logo & Header */}
        <div className="text-center mb-6 sm:mb-8" data-id="element-647">
          <motion.div initial={{
          scale: 0.8
        }} animate={{
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="inline-flex items-center justify-center mb-4 sm:mb-6" data-id="element-648">
            <img src="https://cdn.magicpatterns.com/uploads/rMFF7VCa1dN6Z32dDkPmmj/Logo-anime-_(1).gif" alt="France Décoration" className="w-24 h-24 sm:w-32 sm:h-32 object-contain" data-id="element-649" />
          </motion.div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2" data-id="element-650">
            FRANCE DÉCORATION
          </h1>
          <p className="text-sm sm:text-base text-gray-300" data-id="element-651">
            Plateforme de Gestion de Chantiers
          </p>
        </div>

        {/* Login Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8" data-id="element-652">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-653">
            Connexion
          </h2>

          {error && <motion.div initial={{
          opacity: 0,
          x: -10
        }} animate={{
          opacity: 1,
          x: 0
        }} className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2 text-red-800 text-sm" data-id="element-654">
              <AlertCircle size={16} className="flex-shrink-0 mt-0.5" data-id="element-655" />
              <span data-id="element-656">{error}</span>
            </motion.div>}

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-657">
            <div data-id="element-658">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-659">
                Email
              </label>
              <div className="relative" data-id="element-660">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-661" />
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-fd-teal focus:border-transparent outline-none transition-all text-sm sm:text-base" placeholder="votre.email@francedecoration.fr" required data-id="element-662" />
              </div>
            </div>

            <div data-id="element-663">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-664">
                Mot de passe
              </label>
              <div className="relative" data-id="element-665">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-666" />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-fd-teal focus:border-transparent outline-none transition-all text-sm sm:text-base" placeholder="••••••••" required data-id="element-667" />
              </div>
            </div>

            <Button type="submit" className="w-full" size="lg" isLoading={isLoading} data-id="element-668">
              Se connecter
            </Button>
          </form>

          {/* Demo Quick Login */}
          <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-669">
            <p className="text-xs text-gray-500 text-center mb-3" data-id="element-670">
              Connexion rapide (démo)
            </p>
            <div className="grid grid-cols-2 gap-2" data-id="element-671">
              <button onClick={() => quickLogin('admin')} className="px-2 sm:px-3 py-2 text-xs font-medium bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100 active:scale-95 transition-all" data-id="element-672">
                Naoufel (Dirigeant)
              </button>
              <button onClick={() => quickLogin('bureau')} className="px-2 sm:px-3 py-2 text-xs font-medium bg-teal-50 text-teal-700 rounded-lg hover:bg-teal-100 active:scale-95 transition-all" data-id="element-673">
                Randa (Bureau)
              </button>
              <button onClick={() => quickLogin('chef_equipe')} className="px-2 sm:px-3 py-2 text-xs font-medium bg-amber-50 text-amber-700 rounded-lg hover:bg-teal-100 active:scale-95 transition-all" data-id="element-674">
                Mohamad (Chargé d'aff.)
              </button>
              <button onClick={() => quickLogin('technicien')} className="px-2 sm:px-3 py-2 text-xs font-medium bg-green-50 text-green-700 rounded-lg hover:bg-green-100 active:scale-95 transition-all" data-id="element-675">
                Karim (Technicien)
              </button>
            </div>
          </div>
        </motion.div>

        {/* Footer */}
        <p className="text-center text-gray-300 text-xs sm:text-sm mt-6" data-id="element-676">
          © 2025 France Décoration. Tous droits réservés.
        </p>
      </motion.div>
    </div>;
}